import { combineReducers } from '@reduxjs/toolkit';
import PurchaseReducer from './purchaseEntry/slice';

const purchaseEntryReducer = combineReducers({
  purchaseEntry: PurchaseReducer,
});
export default purchaseEntryReducer;
